import { LogErrors } from './../LogErrors'

import { DoubleAttempt } from './Helpers/DoubleAttempt'


const SaveWebTheme = async (token, themeToSave) => {
    try {
        const dataToSend = {
            "id_UserTheme": themeToSave
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/Api/updateUserTheme"
        
        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/updateUserTheme", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
    
        // // Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('SaveWebTheme - Settings DL', error)
        return { success: false, message: '' }
    }
  }
  
const SaveWebFontSize = async (token, fontSizeToSave) => {
    try {
        const dataToSend = {
            "id_FontZise": fontSizeToSave
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/Api/updateUserFontSize"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/updateUserFontSize", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }

        // // Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('SaveWebFontSize - Settings DL', error)
        return { success: false, message: '' }
    }
}

const UpdateNickname = async (nickname, token) => {
    try {
        const dataToSend = {
            newNickname: nickname
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/UpdateNickname"
        
        const response = await DoubleAttempt(url, parameters, false)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('UpdateNickname - DL Settings', error)
        return { success: false, message: 'No ha sido posible actualizar tu alias. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

















































// Definición de los datos en formato JSON
const settings = {
    "spanish" : {
        "default" : true,
        "login" : {
          "title" : "Iniciar sesión",
          "fieldID" : "Clave del centro",
          "fieldUser" : "Usuario",
          "fieldPassword" : "Contraseña",
          "fieldCheck" : "Recordarme",
          "button" : "Iniciar sesión",
          "buttonLanguage1" : "Español",
          "buttonLanguage2" : "Inglés"
        },
        "menu" : [
            {
                "classIcon" : "iconMenu bi bi-house-door home",
                "text" : "Inicio",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-star star",
                "text" : "Favoritos",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-file-text test",
                "text" : "Evaluaciones",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-people groups",
                "text" : "Grupos",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-mortarboard students",
                "text" : "Estudiantes",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-bar-chart-line progress",
                "text" : "Progreso",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-list-ol topics",
                "text" : "Temario",
                "link" : "#"
            }
        ],
        "profile" : "Student",
        "theme" : "light",
        "quickAccess" : [
            {
                "type" : "teachingMaterial", 
                "indexCourse" : "0",
                "indexExam" : "0",
                "indexTopic" : "1"
            },
            {
                "type" : "teachingMaterial", 
                "indexCourse" : "0",
                "indexExam" : "0",
                "indexTopic" : "1"
            },
            {
                "type" : "teachingMaterial", 
                "indexCourse" : "0",
                "indexExam" : "0",
                "indexTopic" : "1"
            },
            {
                "type" : "activity",
                "indexCourse" : "0",
                "indexActivity" : "0"
            },
            {
                "type" : "exam",
                "indexCourse" : "0",
                "indexExam" : "0"
            }
        ],
        "courses" : [
            {
                "tileClassName" : "",
                "tileIconClass" : "bi bi-file-earmark-excel",
                "typeCourse" : "Certificación",
                "nameCourse" : "Hojas de cálculo",
                "level" : "Enterprise",
                "percentageCompleted" : 50,
                "activeElementClass" : "DegradedExcel",
                "topics" : [
                    {
                        "topic" : "Examen Demo",
                        "competences" : [
                            {
                                "indexTopic" : "0",
                                "name" : "Escritura de textos en las celdas"
                            },
                            {
                                "indexTopic" : "1",
                                "name" : "Creación de gráficas"
                            },
                            {
                                "indexTopic" : "2",
                                "name" : "Creación de fórmulas con operadores aritméticos"
                            },
                            {
                                "activity" : {
                                    "indexActivity" : "0",
                                    "title" : "Actividad #1",
                                    "urlDownloadFile" : "./files/activity/00001.xlsx",
                                    "steps" : [
                                        [
                                            "Abre la hoja de cálculo.",
                                            "En la hoja Alberca olímpica escribe en la celda C26 el texto Comité Internacional de Natación Juvenil.",
                                            "En la celda G33, escribe una fórmula para calcular los metros recorridos al dar 6 vueltas a la alberca (celda G32). Multiplica por los metros de largo de la alberca (celda C29).",
                                            "En la celda G36 escribe una fórmula para calcular las vueltas necesarias para recorrer 400 metros (celda G35). Divide entre los metros de largo de la alberca (celda C29).",
                                            "En la hoja Categorías escribe en la celda combinada B3 el texto Masculino.",
                                            "En la hoja Participantes crea una gráfica de Columna Agrupada 3D utilizando la información del rango de celdas B4:B14 y H4:H14."
                                        ]
                                    ]
                                }
                            }
                        ]
                    }
                ]
            }
        ],
        "material" : [
            {
                "indexCourse" : "0",
                "material" : [
                    {
                        "concepts" : [
                            {
                                "indexTopic" : "0",
                                "content" : "<h1>Escritura de textos en las celdas</h1><p>Las celdas son todos los espacios de una hoja de cálculo en los cuales puedes escribir.</p><img className='Concepts-Images' src='./img/teaching/concepts/one/1.png' alt='Hoja de cálculo de Excel' /><p>Aunque existen varias formas de escribir texto en una celda, existen dos maneras principales que se explican a continuación:</p><ol><li>Utilizando el mouse y el teclado de tu computadora<ul><li>Utiliza el mouse para moverte en la pantalla.</li><li>Haz clic en el espacio donde quieres escribir.</li><li>Utiliza el teclado para escribir lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li><li>Utilizando solamente el teclado de tu computadora<ul><li>Utiliza las flechas de tu teclado para moverte en la pantalla.</li><li>Posiciona el contorno en la celda donde quieres escribir.</li><li>Escribe lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li></ol>",
                                "carrousel" : [
                                    "./img/teaching/concepts/one/examples/1.png",
                                    "./img/teaching/concepts/one/examples/2.png"
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "content" : "<h1>Creación de gráficas</h1><p>Las gráficas son elementos visuales que facilitan la comprensión y el análisis de la información en una hoja de cálculo. A través de las gráficas es posible identificar datos de forma intuitiva, a comparación de analizar la información solamente con números.</p><p>Existen varios tipos de gráficas. Las gráficas más comunes son las siguientes:</p><ul><li><p>Gráficas de barras: Representan los datos mediante barras verticales u horizontales en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/1.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas circulares, también llamadas de sectores, pastel o rebanadas: Representan proporciones de un todo, mostrando cada elemento como parte del círculo, en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/2.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas de líneas: Representan los datos mediante puntos que se conectan de forma consecutiva.</p><img className='Concepts-Images' src='./img/teaching/concepts/two/3.png' alt='Hoja de cálculo de Excel' /></li></ul><p>Las gráficas generalmente pueden personalizarse para mejorar el aspecto visual de los elementos en ella. Por ejemplo, el color de fondo o el color de cada segmento, lo cual te permite mostrar la información en la manera que más te guste o que se adapte a tus necesidades.</p><p>Otros tipos de gráfica que puedes encontrar en una hoja de cálculo son las gráficas de dispersión, gráficas de áreas, gráficas radiales y gráficas de superficie. Sin embargo, es importante saber que las gráficas disponibles en una hoja de cálculo pueden variar según la tecnología o aplicación que utilices.</p>",
                                "carrousel" : [
                                    "./img/teaching/concepts/two/examples/1.png",
                                    "./img/teaching/concepts/two/examples/2.png"
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "content" : "<h1>Creación de fórmulas con operadores aritméticos</h1><p>Las fórmulas en una hoja de cálculo se refieren a las operaciones que se pueden realizar para manipular datos. Las operaciones que se pueden hacer en una hoja de cálculo son variadas; las operaciones más comunes son las operaciones matemáticas, operaciones lógicas, operaciones con texto, operaciones con fechas y operaciones de búsqueda.</p><p>Existen dos maneras de crear una fórmula:</p><ol><li><strong>Escribiendo la fórmula en la celda.</strong></li><li><strong>Escribiendo la fórmula en la barra de fórmulas.</strong></li></ol><p><strong>Nota:</strong> La barra de fórmulas es un espacio en la hoja de cálculo que suele identificarse por contener el término <strong>Fx</strong> y un cuadro donde se puede escribir texto; esta barra se ubica generalmente arriba del área de trabajo.</p><img src='./img/teaching/concepts/three/1.png' /><p>Para crear una fórmula, es necesario que ubiques el selector sobre la celda donde se realizará el cálculo y que comiences escribiendo un signo de igualdad, seguido de las operaciones que deben realizarse. Las fórmulas, aceptan valores fijos como <strong>3+1</strong>, referencias de celda como <strong>A1+B1</strong> o incluso, nombres de rango como <strong>VentasSemestre1+VentasSemestre2.</strong></p><p>Los cálculos matemáticos más simples como la suma, resta, multiplicación y división se especifican mediante sus operadores aritméticos (+, -, *, /) los cuales se rigen por la jerarquía de operadores. A continuación, se muestran algunos ejemplos de fórmulas que contienen operadores aritméticos.</p><ol><li><strong>Suma de cuatro números: </strong><img src='./img/teaching/concepts/three/2.png' /></li><li><strong>Resta de dos números: </strong><img src='./img/teaching/concepts/three/3.png' /></li><li><strong>Multiplicación de dos números: </strong><img src='./img/teaching/concepts/three/4.png' /></li><li><strong>División de dos números: </strong><img src='./img/teaching/concepts/three/5.png' /></li></ol><p>Más adelante, aprenderás a utilizar otros elementos llamados Funciones, los cuáles realizan cálculos de manera automática y pueden ahorrarte el uso de operadores aritméticos.</p>",
                                "carrousel" : [
                                    "./img/teaching/concepts/three/examples/1.png",
                                    "./img/teaching/concepts/three/examples/2.png"
                                ]
                            }
                        ]
                    },
                    {
                        "quizzes" : [
                            {
                                "indexTopic" : "0",
                                "questions" : [
                                    {
                                        "question" : "¿Cómo puedes escribir texto en las celdas?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Una de las formas principales para escribir texto es mediante el uso del teclado de la computadora.",
                                        "options" : [
                                            {
                                                "text" : "Utilizando el teclado de mi computadora",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Utilizando una lámpara"
                                            },
                                            {
                                                "text" : "Utilizando un lápiz"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Cómo puedes hacer una lista de los animales que más te gustan?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Para crear una lista de los animales que más te gustan, lo primero es escribir sus nombres en las celdas de la hoja de cálculo",
                                        "options" : [
                                            {
                                                "text" : "Escribiendo sus nombres en las celdas",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Coloreando un libro"
                                            },
                                            {
                                                "text" : "Resolviendo acertijos"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "questions" : [
                                    {
                                        "question" : "Si quisieras analizar los porcentajes que representan los datos dentro de un todo, ¿Qué gráfica te permite hacerlo de manera más sencilla?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Aunque las gráficas de líneas y de barras te permiten analizar la información de varias maneras, una gráfica circular facilita el análisis de cada parte a través de porcentajes.",
                                        "options" : [
                                            {
                                                "text" : "Gráfica circular",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Gráfica de líneas"
                                            },
                                            {
                                                "text" : "Gráfica de barras"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "Si una persona quiere mostrar cuánto ha vendido de cada producto y al mismo tiempo desea comparar la venta de todos sus productos, ¿Qué gráfica debe utilizar para facilitar el análisis?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Aunque es posible utilizar varias gráficas para mostrar y comparar la venta de productos, una gráfica de barras facilita el análisis de los datos permitiendo observar cada parte y compararla con las demás",
                                        "options" : [
                                            {
                                                "text" : "Gráfica circular"
                                            },
                                            {
                                                "text" : "Gráfica de barras",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Gráfica radial"
                                            }
                                        ]
                                    },
                                    
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "questions" : [
                                    {
                                        "question" : "Quieres calcular cuánto dinero te queda a partir de lo que has gastado. Tu dinero total se encuentra en C4 y el total de tus gastos en D6, ¿Qué operación resuelve tu necesidad?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Para calcular cuánto dinero has gastado, debes restar el total de gastos al total original.",
                                        "options" : [
                                            {
                                                "text" : "=D6-D4"
                                            },
                                            {
                                                "text" : "=C4-D6",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "=D4+D6"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Cuáles son las dos formas de crear una fórmula con operadores aritméticos en una hoja de cálculo?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Se puede crear una fórmula con operadores aritméticos escribiendo directamente en la celda y escribiendo en la barra de fórmulas.",
                                        "options" : [
                                            {
                                                "text" : "Escribiendo en la celda y escribiendo en la barra de fórmulas",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Escribiendo en la celda y escribiendo en el cuadro de nombres"
                                            },
                                            {
                                                "text" : "Escribiendo en la barra de fórmulas y en el cuadro de nombres"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Para qué sirve el signo de igualdad en una fórmula?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Las fórmulas de una hoja de cálculo comienzan por un signo de igualdad para indicarle a la hoja que la celda contiene operaciones.",
                                        "options" : [
                                            {
                                                "text" : "Para indicarle a la hoja de cálculo que la celda contiene operaciones",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Para especificar que la celda y la barra de fórmulas son iguales"
                                            },
                                            {
                                                "text" : "Para igualar el valor de la celda al valor de la barra de fórmulas"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "Estás realizando operaciones en una hoja de cálculo y deseas calcular el cuadrado del número 5. ¿Cuál es la fórmula correcta?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! En las hojas de cálculo, las operaciones comienzan con el signo de igualdad, seguido de las operaciones; además, el asterisco * suele utilizarse como el operador de multiplicación.",
                                        "options" : [
                                            {
                                                "text" : "=5*5",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "5x5"
                                            },
                                            {
                                                "text" : "5*5"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "videos" : [
                            {
                                "indexTopic" : "0",
                                "urlVideo" : "./videos/teaching/concepts/one/1.mp4"
                            },
                            {
                                "indexTopic" : "1",
                                "urlVideo" : "./videos/teaching/concepts/two/1.mp4"
                            },
                            {
                                "indexTopic" : "2",
                                "urlVideo" : "./videos/teaching/concepts/three/1.mp4"
                            }
                        ]
                    },
                    {
                        "challenges" : [
                            {
                                "indexTopic" : "0",
                                "instruction" : "Selecciona la imagen que muestre una lista de animales en las celdas",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/one/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/one/2.png"
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "instruction" : "Imagina que tienes un canal de vídeos; quieres saber en qué meses tuviste menos vistas y cuántas vistas fueron. Selecciona la gráfica que te permite observar esos datos",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/two/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/two/2.png"
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "instruction" : "Un granjero ha vendido la mitad de sus terrenos. ¿Cuál es la imagen que calcula correctamente el dinero que ha recibido?",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/three/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/three/2.png"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "english" : {
        "default" : false,
        "login" : {
          "title" : "Login",
          "fieldID" : "Center key",
          "fieldUser" : "User",
          "fieldPassword" : "Password",
          "fieldCheck" : "Remember me",
          "button" : "Login",
          "buttonLanguage1" : "Spanish",
          "buttonLanguage2" : "English"
        },
        "menu" : [
            {
                "classIcon" : "iconMenu bi bi-house-door home",
                "text" : "Home",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-star star",
                "text" : "Favorites",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-file-text test",
                "text" : "Tests",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-people groups",
                "text" : "Groups",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-mortarboard students",
                "text" : "Students",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-bar-chart-line progress",
                "text" : "Progress",
                "link" : "#"
            },
            {
                "classIcon" : "iconMenu bi bi-list-ol topics",
                "text" : "Topics",
                "link" : "#"
            }
        ],
        "profile" : "Student",
        "theme" : "light",
        "quickAccess" : [
            {
                "type" : "teachingMaterial", 
                "indexCourse" : "0",
                "indexExam" : "0",
                "indexTopic" : "1"
            },
            {
                "type" : "activity",
                "indexCourse" : "0",
                "indexActivity" : "0"
            },
            {
                "type" : "exam",
                "indexCourse" : "0",
                "indexExam" : "0"
            }
        ],
        "courses" : [
            {
                "tileClassName" : "",
                "tileIconClass" : "bi bi-file-earmark-excel",
                "typeCourse" : "Certification",
                "nameCourse" : "Spreadsheets",
                "level" : "Enterprise",
                "percentageCompleted" : 50,
                "activeElementClass" : "DegradedExcel",
                "topics" : [
                    {
                        "topic" : "Demo Exam",
                        "competences" : [
                            {
                                "indexTopic" : "0",
                                "name" : "Escritura de textos en las celdas"
                            },
                            {
                                "indexTopic" : "1",
                                "name" : "Creación de gráficas"
                            },
                            {
                                "indexTopic" : "2",
                                "name" : "Creación de fórmulas con operadores aritméticos"
                            },
                            {
                                "activity" : {
                                    "indexActivity" : "0",
                                    "title" : "Activity #1",
                                    "urlDownloadFile" : "./files/activity/00001.xlsx",
                                    "steps" : [
                                        [
                                            "Abre la hoja de cálculo.",
                                            "En la hoja Alberca olímpica escribe en la celda C26 el texto Comité Internacional de Natación Juvenil.",
                                            "En la celda G33, escribe una fórmula para calcular los metros recorridos al dar 6 vueltas a la alberca (celda G32). Multiplica por los metros de largo de la alberca (celda C29).",
                                            "En la celda G36 escribe una fórmula para calcular las vueltas necesarias para recorrer 400 metros (celda G35). Divide entre los metros de largo de la alberca (celda C29).",
                                            "En la hoja Categorías escribe en la celda combinada B3 el texto Masculino.",
                                            "En la hoja Participantes crea una gráfica de Columna Agrupada 3D utilizando la información del rango de celdas B4:B14 y H4:H14."
                                        ]
                                    ]
                                }
                            }
                        ]
                    }
                ]
            }
        ],
        "material" : [
            {
                "indexCourse" : "0",
                "material" : [
                    {
                        "concepts" : [
                            {
                                "indexTopic" : "0",
                                "content" : "<h1>Escritura de textos en las celdas</h1><p>Las celdas son todos los espacios de una hoja de cálculo en los cuales puedes escribir.</p><img className='Concepts-Images' src='./img/teaching/concepts/one/1.png' alt='Hoja de cálculo de Excel' /><p>Aunque existen varias formas de escribir texto en una celda, existen dos maneras principales que se explican a continuación:</p><ol><li>Utilizando el mouse y el teclado de tu computadora<ul><li>Utiliza el mouse para moverte en la pantalla.</li><li>Haz clic en el espacio donde quieres escribir.</li><li>Utiliza el teclado para escribir lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li><li>Utilizando solamente el teclado de tu computadora<ul><li>Utiliza las flechas de tu teclado para moverte en la pantalla.</li><li>Posiciona el contorno en la celda donde quieres escribir.</li><li>Escribe lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li></ol>",
                                "carrousel" : [
                                    "./img/teaching/concepts/one/examples/1.png",
                                    "./img/teaching/concepts/one/examples/2.png"
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "content" : "<h1>Creación de gráficas</h1><p>Las gráficas son elementos visuales que facilitan la comprensión y el análisis de la información en una hoja de cálculo. A través de las gráficas es posible identificar datos de forma intuitiva, a comparación de analizar la información solamente con números.</p><p>Existen varios tipos de gráficas. Las gráficas más comunes son las siguientes:</p><ul><li><p>Gráficas de barras: Representan los datos mediante barras verticales u horizontales en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/1.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas circulares, también llamadas de sectores, pastel o rebanadas: Representan proporciones de un todo, mostrando cada elemento como parte del círculo, en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/2.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas de líneas: Representan los datos mediante puntos que se conectan de forma consecutiva.</p><img className='Concepts-Images' src='./img/teaching/concepts/two/3.png' alt='Hoja de cálculo de Excel' /></li></ul><p>Las gráficas generalmente pueden personalizarse para mejorar el aspecto visual de los elementos en ella. Por ejemplo, el color de fondo o el color de cada segmento, lo cual te permite mostrar la información en la manera que más te guste o que se adapte a tus necesidades.</p><p>Otros tipos de gráfica que puedes encontrar en una hoja de cálculo son las gráficas de dispersión, gráficas de áreas, gráficas radiales y gráficas de superficie. Sin embargo, es importante saber que las gráficas disponibles en una hoja de cálculo pueden variar según la tecnología o aplicación que utilices.</p>",
                                "carrousel" : [
                                    "./img/teaching/concepts/two/examples/1.png",
                                    "./img/teaching/concepts/two/examples/2.png"
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "content" : "<h1>Creación de fórmulas con operadores aritméticos</h1><p>Las fórmulas en una hoja de cálculo se refieren a las operaciones que se pueden realizar para manipular datos. Las operaciones que se pueden hacer en una hoja de cálculo son variadas; las operaciones más comunes son las operaciones matemáticas, operaciones lógicas, operaciones con texto, operaciones con fechas y operaciones de búsqueda.</p><p>Existen dos maneras de crear una fórmula:</p><ol><li><strong>Escribiendo la fórmula en la celda.</strong></li><li><strong>Escribiendo la fórmula en la barra de fórmulas.</strong></li></ol><p><strong>Nota:</strong> La barra de fórmulas es un espacio en la hoja de cálculo que suele identificarse por contener el término <strong>Fx</strong> y un cuadro donde se puede escribir texto; esta barra se ubica generalmente arriba del área de trabajo.</p><img src='./img/teaching/concepts/three/1.png' /><p>Para crear una fórmula, es necesario que ubiques el selector sobre la celda donde se realizará el cálculo y que comiences escribiendo un signo de igualdad, seguido de las operaciones que deben realizarse. Las fórmulas, aceptan valores fijos como <strong>3+1</strong>, referencias de celda como <strong>A1+B1</strong> o incluso, nombres de rango como <strong>VentasSemestre1+VentasSemestre2.</strong></p><p>Los cálculos matemáticos más simples como la suma, resta, multiplicación y división se especifican mediante sus operadores aritméticos (+, -, *, /) los cuales se rigen por la jerarquía de operadores. A continuación, se muestran algunos ejemplos de fórmulas que contienen operadores aritméticos.</p><ol><li><strong>Suma de cuatro números: </strong><img src='./img/teaching/concepts/three/2.png' /></li><li><strong>Resta de dos números: </strong><img src='./img/teaching/concepts/three/3.png' /></li><li><strong>Multiplicación de dos números: </strong><img src='./img/teaching/concepts/three/4.png' /></li><li><strong>División de dos números: </strong><img src='./img/teaching/concepts/three/5.png' /></li></ol><p>Más adelante, aprenderás a utilizar otros elementos llamados Funciones, los cuáles realizan cálculos de manera automática y pueden ahorrarte el uso de operadores aritméticos.</p>",
                                "carrousel" : [
                                    "./img/teaching/concepts/three/examples/1.png",
                                    "./img/teaching/concepts/three/examples/2.png"
                                ]
                            }
                        ]
                    },
                    {
                        "quizzes" : [
                            {
                                "indexTopic" : "0",
                                "questions" : [
                                    {
                                        "question" : "¿Cómo puedes escribir texto en las celdas?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Una de las formas principales para escribir texto es mediante el uso del teclado de la computadora.",
                                        "options" : [
                                            {
                                                "text" : "Utilizando el teclado de mi computadora",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Utilizando una lámpara"
                                            },
                                            {
                                                "text" : "Utilizando un lápiz"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Cómo puedes hacer una lista de los animales que más te gustan?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Para crear una lista de los animales que más te gustan, lo primero es escribir sus nombres en las celdas de la hoja de cálculo",
                                        "options" : [
                                            {
                                                "text" : "Escribiendo sus nombres en las celdas",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Coloreando un libro"
                                            },
                                            {
                                                "text" : "Resolviendo acertijos"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "questions" : [
                                    {
                                        "question" : "Si quisieras analizar los porcentajes que representan los datos dentro de un todo, ¿Qué gráfica te permite hacerlo de manera más sencilla?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Aunque las gráficas de líneas y de barras te permiten analizar la información de varias maneras, una gráfica circular facilita el análisis de cada parte a través de porcentajes.",
                                        "options" : [
                                            {
                                                "text" : "Gráfica circular",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Gráfica de líneas"
                                            },
                                            {
                                                "text" : "Gráfica de barras"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "Si una persona quiere mostrar cuánto ha vendido de cada producto y al mismo tiempo desea comparar la venta de todos sus productos, ¿Qué gráfica debe utilizar para facilitar el análisis?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Aunque es posible utilizar varias gráficas para mostrar y comparar la venta de productos, una gráfica de barras facilita el análisis de los datos permitiendo observar cada parte y compararla con las demás",
                                        "options" : [
                                            {
                                                "text" : "Gráfica circular"
                                            },
                                            {
                                                "text" : "Gráfica de barras",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Gráfica radial"
                                            }
                                        ]
                                    },
                                    
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "questions" : [
                                    {
                                        "question" : "Quieres calcular cuánto dinero te queda a partir de lo que has gastado. Tu dinero total se encuentra en C4 y el total de tus gastos en D6, ¿Qué operación resuelve tu necesidad?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Para calcular cuánto dinero has gastado, debes restar el total de gastos al total original.",
                                        "options" : [
                                            {
                                                "text" : "=D6-D4"
                                            },
                                            {
                                                "text" : "=C4-D6",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "=D4+D6"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Cuáles son las dos formas de crear una fórmula con operadores aritméticos en una hoja de cálculo?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Se puede crear una fórmula con operadores aritméticos escribiendo directamente en la celda y escribiendo en la barra de fórmulas.",
                                        "options" : [
                                            {
                                                "text" : "Escribiendo en la celda y escribiendo en la barra de fórmulas",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Escribiendo en la celda y escribiendo en el cuadro de nombres"
                                            },
                                            {
                                                "text" : "Escribiendo en la barra de fórmulas y en el cuadro de nombres"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "¿Para qué sirve el signo de igualdad en una fórmula?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! Las fórmulas de una hoja de cálculo comienzan por un signo de igualdad para indicarle a la hoja que la celda contiene operaciones.",
                                        "options" : [
                                            {
                                                "text" : "Para indicarle a la hoja de cálculo que la celda contiene operaciones",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "Para especificar que la celda y la barra de fórmulas son iguales"
                                            },
                                            {
                                                "text" : "Para igualar el valor de la celda al valor de la barra de fórmulas"
                                            }
                                        ]
                                    },
                                    {
                                        "question" : "Estás realizando operaciones en una hoja de cálculo y deseas calcular el cuadrado del número 5. ¿Cuál es la fórmula correcta?",
                                        "messageGood" : "¡Correcto!",
                                        "messageBad" : "¡Incorrecto! En las hojas de cálculo, las operaciones comienzan con el signo de igualdad, seguido de las operaciones; además, el asterisco * suele utilizarse como el operador de multiplicación.",
                                        "options" : [
                                            {
                                                "text" : "=5*5",
                                                "isCorrect" : true
                                            },
                                            {
                                                "text" : "5x5"
                                            },
                                            {
                                                "text" : "5*5"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "videos" : [
                            {
                                "indexTopic" : "0",
                                "urlVideo" : "./videos/teaching/concepts/one/1.mp4"
                            },
                            {
                                "indexTopic" : "1",
                                "urlVideo" : "./videos/teaching/concepts/two/1.mp4"
                            },
                            {
                                "indexTopic" : "2",
                                "urlVideo" : "./videos/teaching/concepts/three/1.mp4"
                            }
                        ]
                    },
                    {
                        "challenges" : [
                            {
                                "indexTopic" : "0",
                                "instruction" : "Selecciona la imagen que muestre una lista de animales en las celdas",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/one/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/one/2.png"
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "1",
                                "instruction" : "Imagina que tienes un canal de vídeos; quieres saber en qué meses tuviste menos vistas y cuántas vistas fueron. Selecciona la gráfica que te permite observar esos datos",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/two/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/two/2.png"
                                    }
                                ]
                            },
                            {
                                "indexTopic" : "2",
                                "instruction" : "Un granjero ha vendido la mitad de sus terrenos. ¿Cuál es la imagen que calcula correctamente el dinero que ha recibido?",
                                "options" : [
                                    {
                                        "urlImage" : "./img/teaching/challenge/three/1.png",
                                        "isCorrect" : true
                                    },
                                    {
                                        "urlImage" : "./img/teaching/challenge/three/2.png"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
}













// const settings = {
//     "profile" : "student",
//     "theme" : "light",
//     "quickAccess" : [
//         {
//             "type" : "teachingMaterial", 
//             "indexCourse" : "0",
//             "indexExam" : "0",
//             "indexTopic" : "1"
//         },
//         {
//             "type" : "activity",
//             "indexCourse" : "0",
//             "indexActivity" : "0"
//         },
//         {
//             "type" : "exam",
//             "indexCourse" : "0",
//             "indexExam" : "0"
//         }
//     ],
//     "courses" : [
//         {
//             "tileClassName" : "",
//             "tileIconClass" : "bi bi-file-earmark-excel",
//             "typeCourse" : "Certificación",
//             "nameCourse" : "Hojas de cálculo",
//             "level" : "Enterprise",
//             "activeElementClass" : "DegradedExcel",
//             "topics" : [
//                 {
//                     "topic" : "Examen Demo",
//                     "competences" : [
//                         {
//                             "indexTopic" : "0",
//                             "name" : "Escritura de textos en las celdas"
//                         },
//                         {
//                             "indexTopic" : "1",
//                             "name" : "Creación de gráficas"
//                         },
//                         {
//                             "indexTopic" : "2",
//                             "name" : "Creación de fórmulas con operadores aritméticos"
//                         },
//                         {
//                             "activity" : {
//                                 "indexActivity" : "0",
//                                 "title" : "Actividad #1",
//                                 "urlDownloadFile" : "./files/activity/00001.xlsx",
//                                 "steps" : [
//                                     [
//                                         "Abre la hoja de cálculo.",
//                                         "En la hoja Alberca olímpica escribe en la celda C26 el texto Comité Internacional de Natación Juvenil.",
//                                         "En la celda G33, escribe una fórmula para calcular los metros recorridos al dar 6 vueltas a la alberca (celda G32). Multiplica por los metros de largo de la alberca (celda C29).",
//                                         "En la celda G36 escribe una fórmula para calcular las vueltas necesarias para recorrer 400 metros (celda G35). Divide entre los metros de largo de la alberca (celda C29).",
//                                         "En la hoja Categorías escribe en la celda combinada B3 el texto Masculino.",
//                                         "En la hoja Participantes crea una gráfica de Columna Agrupada 3D utilizando la información del rango de celdas B4:B14 y H4:H14."
//                                     ]
//                                 ]
//                             }
//                         }
//                     ]
//                 }
//             ]
//         }
//     ],
//     "material" : [
//         {
//             "indexCourse" : "0",
//             "material" : [
//                 {
//                     "concepts" : [
//                         {
//                             "indexTopic" : "0",
//                             "content" : "<h1>Escritura de textos en las celdas</h1><p>Las celdas son todos los espacios de una hoja de cálculo en los cuales puedes escribir.</p><img className='Concepts-Images' src='./img/teaching/concepts/one/1.png' alt='Hoja de cálculo de Excel' /><p>Aunque existen varias formas de escribir texto en una celda, existen dos maneras principales que se explican a continuación:</p><ol><li>Utilizando el mouse y el teclado de tu computadora<ul><li>Utiliza el mouse para moverte en la pantalla.</li><li>Haz clic en el espacio donde quieres escribir.</li><li>Utiliza el teclado para escribir lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li><li>Utilizando solamente el teclado de tu computadora<ul><li>Utiliza las flechas de tu teclado para moverte en la pantalla.</li><li>Posiciona el contorno en la celda donde quieres escribir.</li><li>Escribe lo que quieres.</li><li>Presiona la tecla Enter o alguna flecha en tu teclado para que la celda sepa que has terminado de escribir.</li></ul></li></ol>",
//                             "carrousel" : [
//                                 "./img/teaching/concepts/one/examples/1.png",
//                                 "./img/teaching/concepts/one/examples/2.png"
//                             ]
//                         },
//                         {
//                             "indexTopic" : "1",
//                             "content" : "<h1>Creación de gráficas</h1><p>Las gráficas son elementos visuales que facilitan la comprensión y el análisis de la información en una hoja de cálculo. A través de las gráficas es posible identificar datos de forma intuitiva, a comparación de analizar la información solamente con números.</p><p>Existen varios tipos de gráficas. Las gráficas más comunes son las siguientes:</p><ul><li><p>Gráficas de barras: Representan los datos mediante barras verticales u horizontales en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/1.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas circulares, también llamadas de sectores, pastel o rebanadas: Representan proporciones de un todo, mostrando cada elemento como parte del círculo, en dos o tres dimensiones (2D / 3D).</p><img className='Concepts-Images' src='./img/teaching/concepts/two/2.png' alt='Hoja de cálculo de Excel' /></li><li><p>Gráficas de líneas: Representan los datos mediante puntos que se conectan de forma consecutiva.</p><img className='Concepts-Images' src='./img/teaching/concepts/two/3.png' alt='Hoja de cálculo de Excel' /></li></ul><p>Las gráficas generalmente pueden personalizarse para mejorar el aspecto visual de los elementos en ella. Por ejemplo, el color de fondo o el color de cada segmento, lo cual te permite mostrar la información en la manera que más te guste o que se adapte a tus necesidades.</p><p>Otros tipos de gráfica que puedes encontrar en una hoja de cálculo son las gráficas de dispersión, gráficas de áreas, gráficas radiales y gráficas de superficie. Sin embargo, es importante saber que las gráficas disponibles en una hoja de cálculo pueden variar según la tecnología o aplicación que utilices.</p>",
//                             "carrousel" : [
//                                 "./img/teaching/concepts/two/examples/1.png",
//                                 "./img/teaching/concepts/two/examples/2.png"
//                             ]
//                         },
//                         {
//                             "indexTopic" : "2",
//                             "content" : "<h1>Creación de fórmulas con operadores aritméticos</h1><p>Las fórmulas en una hoja de cálculo se refieren a las operaciones que se pueden realizar para manipular datos. Las operaciones que se pueden hacer en una hoja de cálculo son variadas; las operaciones más comunes son las operaciones matemáticas, operaciones lógicas, operaciones con texto, operaciones con fechas y operaciones de búsqueda.</p><p>Existen dos maneras de crear una fórmula:</p><ol><li><strong>Escribiendo la fórmula en la celda.</strong></li><li><strong>Escribiendo la fórmula en la barra de fórmulas.</strong></li></ol><p><strong>Nota:</strong> La barra de fórmulas es un espacio en la hoja de cálculo que suele identificarse por contener el término <strong>Fx</strong> y un cuadro donde se puede escribir texto; esta barra se ubica generalmente arriba del área de trabajo.</p><img src='./img/teaching/concepts/three/1.png' /><p>Para crear una fórmula, es necesario que ubiques el selector sobre la celda donde se realizará el cálculo y que comiences escribiendo un signo de igualdad, seguido de las operaciones que deben realizarse. Las fórmulas, aceptan valores fijos como <strong>3+1</strong>, referencias de celda como <strong>A1+B1</strong> o incluso, nombres de rango como <strong>VentasSemestre1+VentasSemestre2.</strong></p><p>Los cálculos matemáticos más simples como la suma, resta, multiplicación y división se especifican mediante sus operadores aritméticos (+, -, *, /) los cuales se rigen por la jerarquía de operadores. A continuación, se muestran algunos ejemplos de fórmulas que contienen operadores aritméticos.</p><ol><li><strong>Suma de cuatro números: </strong><img src='./img/teaching/concepts/three/2.png' /></li><li><strong>Resta de dos números: </strong><img src='./img/teaching/concepts/three/3.png' /></li><li><strong>Multiplicación de dos números: </strong><img src='./img/teaching/concepts/three/4.png' /></li><li><strong>División de dos números: </strong><img src='./img/teaching/concepts/three/5.png' /></li></ol><p>Más adelante, aprenderás a utilizar otros elementos llamados Funciones, los cuáles realizan cálculos de manera automática y pueden ahorrarte el uso de operadores aritméticos.</p>",
//                             "carrousel" : [
//                                 "./img/teaching/concepts/three/examples/1.png",
//                                 "./img/teaching/concepts/three/examples/2.png"
//                             ]
//                         }
//                     ]
//                 },
//                 {
//                     "quizzes" : [
//                         {
//                             "indexTopic" : "0",
//                             "questions" : [
//                                 {
//                                     "question" : "¿Cómo puedes escribir texto en las celdas?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Una de las formas principales para escribir texto es mediante el uso del teclado de la computadora.",
//                                     "options" : [
//                                         {
//                                             "text" : "Utilizando el teclado de mi computadora",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Utilizando una lámpara"
//                                         },
//                                         {
//                                             "text" : "Utilizando un lápiz"
//                                         }
//                                     ]
//                                 },
//                                 {
//                                     "question" : "¿Cómo puedes hacer una lista de los animales que más te gustan?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Para crear una lista de los animales que más te gustan, lo primero es escribir sus nombres en las celdas de la hoja de cálculo",
//                                     "options" : [
//                                         {
//                                             "text" : "Escribiendo sus nombres en las celdas",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Coloreando un libro"
//                                         },
//                                         {
//                                             "text" : "Resolviendo acertijos"
//                                         }
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "indexTopic" : "1",
//                             "questions" : [
//                                 {
//                                     "question" : "Si quisieras analizar los porcentajes que representan los datos dentro de un todo, ¿Qué gráfica te permite hacerlo de manera más sencilla?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Aunque las gráficas de líneas y de barras te permiten analizar la información de varias maneras, una gráfica circular facilita el análisis de cada parte a través de porcentajes.",
//                                     "options" : [
//                                         {
//                                             "text" : "Gráfica circular",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Gráfica de líneas"
//                                         },
//                                         {
//                                             "text" : "Gráfica de barras"
//                                         }
//                                     ]
//                                 },
//                                 {
//                                     "question" : "Si una persona quiere mostrar cuánto ha vendido de cada producto y al mismo tiempo desea comparar la venta de todos sus productos, ¿Qué gráfica debe utilizar para facilitar el análisis?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Aunque es posible utilizar varias gráficas para mostrar y comparar la venta de productos, una gráfica de barras facilita el análisis de los datos permitiendo observar cada parte y compararla con las demás",
//                                     "options" : [
//                                         {
//                                             "text" : "Gráfica circular"
//                                         },
//                                         {
//                                             "text" : "Gráfica de barras",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Gráfica radial"
//                                         }
//                                     ]
//                                 },
                                
//                             ]
//                         },
//                         {
//                             "indexTopic" : "2",
//                             "questions" : [
//                                 {
//                                     "question" : "Quieres calcular cuánto dinero te queda a partir de lo que has gastado. Tu dinero total se encuentra en C4 y el total de tus gastos en D6, ¿Qué operación resuelve tu necesidad?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Para calcular cuánto dinero has gastado, debes restar el total de gastos al total original.",
//                                     "options" : [
//                                         {
//                                             "text" : "=D6-D4"
//                                         },
//                                         {
//                                             "text" : "=C4-D6",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "=D4+D6"
//                                         }
//                                     ]
//                                 },
//                                 {
//                                     "question" : "¿Cuáles son las dos formas de crear una fórmula con operadores aritméticos en una hoja de cálculo?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Se puede crear una fórmula con operadores aritméticos escribiendo directamente en la celda y escribiendo en la barra de fórmulas.",
//                                     "options" : [
//                                         {
//                                             "text" : "Escribiendo en la celda y escribiendo en la barra de fórmulas",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Escribiendo en la celda y escribiendo en el cuadro de nombres"
//                                         },
//                                         {
//                                             "text" : "Escribiendo en la barra de fórmulas y en el cuadro de nombres"
//                                         }
//                                     ]
//                                 },
//                                 {
//                                     "question" : "¿Para qué sirve el signo de igualdad en una fórmula?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! Las fórmulas de una hoja de cálculo comienzan por un signo de igualdad para indicarle a la hoja que la celda contiene operaciones.",
//                                     "options" : [
//                                         {
//                                             "text" : "Para indicarle a la hoja de cálculo que la celda contiene operaciones",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "Para especificar que la celda y la barra de fórmulas son iguales"
//                                         },
//                                         {
//                                             "text" : "Para igualar el valor de la celda al valor de la barra de fórmulas"
//                                         }
//                                     ]
//                                 },
//                                 {
//                                     "question" : "Estás realizando operaciones en una hoja de cálculo y deseas calcular el cuadrado del número 5. ¿Cuál es la fórmula correcta?",
//                                     "messageGood" : "¡Correcto!",
//                                     "messageBad" : "¡Incorrecto! En las hojas de cálculo, las operaciones comienzan con el signo de igualdad, seguido de las operaciones; además, el asterisco * suele utilizarse como el operador de multiplicación.",
//                                     "options" : [
//                                         {
//                                             "text" : "=5*5",
//                                             "isCorrect" : true
//                                         },
//                                         {
//                                             "text" : "5x5"
//                                         },
//                                         {
//                                             "text" : "5*5"
//                                         }
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                 },
//                 {
//                     "videos" : [
//                         {
//                             "indexTopic" : "0",
//                             "urlVideo" : "./videos/teaching/concepts/one/1.mp4"
//                         },
//                         {
//                             "indexTopic" : "1",
//                             "urlVideo" : "./videos/teaching/concepts/two/1.mp4"
//                         },
//                         {
//                             "indexTopic" : "2",
//                             "urlVideo" : "./videos/teaching/concepts/three/1.mp4"
//                         }
//                     ]
//                 },
//                 {
//                     "challenges" : [
//                         {
//                             "indexTopic" : "0",
//                             "instruction" : "Selecciona la imagen que muestre una lista de animales en las celdas",
//                             "options" : [
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/one/1.png",
//                                     "isCorrect" : true
//                                 },
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/one/2.png"
//                                 }
//                             ]
//                         },
//                         {
//                             "indexTopic" : "1",
//                             "instruction" : "Imagina que tienes un canal de vídeos; quieres saber en qué meses tuviste menos vistas y cuántas vistas fueron. Selecciona la gráfica que te permite observar esos datos",
//                             "options" : [
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/two/1.png",
//                                     "isCorrect" : true
//                                 },
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/two/2.png"
//                                 }
//                             ]
//                         },
//                         {
//                             "indexTopic" : "2",
//                             "instruction" : "Un granjero ha vendido la mitad de sus terrenos. ¿Cuál es la imagen que calcula correctamente el dinero que ha recibido?",
//                             "options" : [
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/three/1.png",
//                                     "isCorrect" : true
//                                 },
//                                 {
//                                     "urlImage" : "./img/teaching/challenge/three/2.png"
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         }
//     ]
// }















//activity //teachingMaterial //exam

//teachingMaterial
// "current" : {
//     "type" : "teachingMaterial", 
//     "indexCourse" : "",
//     "indexExam" : ""
//     "indexTopic" : ""
// }

//activity
// "current" : {
//     "type" : "activity",
//     "indexCourse" : "",
//     "indexActivity" : ""
// }

//exam
// "current" : {
//     "type" : "exam",
//     "indexCourse" : "",
//     "indexExam" : ""
// }


/**
 * Función para obtener las configuraciones de la plataforma
 * @param {string} language 
 * @param {boolean} isLoginPage 
 * @returns 
 */
function DLGetSettings(language = null, isLoginPage = false) {
    try {
        let Info = null

        if (language !== null && language !== '') {
            let tmpInfo = settings[language]

            if (tmpInfo !== undefined && tmpInfo !== null) {
                sessionStorage.setItem('settings', JSON.stringify(settings[language]))
                Info = settings[language]
            }
        } else if (isLoginPage) {
            for (const language in settings) {
                if (settings[language].default) { 
                  sessionStorage.setItem('settings', JSON.stringify(settings[language]))
                  Info = settings[language]
                  break
                }
            }
        } else {
            if (sessionStorage.getItem('settings')) {
                Info = JSON.parse(sessionStorage.getItem('settings'))
            } else {
                for (const language in settings) {
                    if (settings[language].default) { 
                      sessionStorage.setItem('settings', JSON.stringify(settings[language]))
                      Info = settings[language]
                      break
                    }
                }
            }
        }

        return Info
    } catch (error) {
        console.log(error)
    }
}

//export { settings, getMe };
export { SaveWebTheme, SaveWebFontSize, DLGetSettings, UpdateNickname };





// {
//     "default" : true,
//     "quickAccess" : [
//         {
//             "indexCourse" : 0,
//             "indexCompetence" : 1
//         },
//         {
//             "indexCourse" : 1,
//             "indexCompetence" : 0
//         },
//         {
//             "indexCourse" : 2,
//             "indexCompetence" : 2
//         }
//     ],
//     "courses" : [
//         {
//             "tileClassName" : "",
//             "tileIconClass" : "",
//             "typeCourse" : "",
//             "nameCourse" : "",
//             "level" : "",
//             "percentageCompleted" : 0,
//             "activeElementClass" : "",
//             "topics" : [
//                 {
//                     "topic" : "Fórmulas y funciones de Excel",
//                     "competences" : [
//                         {
//                             "name" : "Competencia #1"
//                         },
//                         {
//                             "name" : "Competencia #2"
//                         },
//                         {
//                             "name" : "Competencia #3"
//                         }
//                     ]
//                 },
//                 {
//                     "topic" : "Tablas e informes dinámicos",
//                     "competences" : [
//                         {
//                             "name" : "Competencia #4"
//                         },
//                         {
//                             "name" : "Competencia #5"
//                         },
//                         {
//                             "name" : "Competencia #6"
//                         }
//                     ]
//                 },
//                 {
//                     "topic" : "Gráficos dinámicos",
//                     "competences" : [
//                         {
//                             "name" : "Competencia #7"
//                         },
//                         {
//                             "name" : "Competencia #8"
//                         },
//                         {
//                             "name" : "Competencia #9"
//                         }
//                     ]
//                 }
//             ]
//         }
//     ]
// }



// const courses = [
//     { tileClassName: '', tileIconClass: '', typeCourse: '', nameCourse: '', competence: '', activeElementClass: '' },
//     { tileClassName: '', tileIconClass: '', typeCourse: '', nameCourse: '', competence: '', activeElementClass: null },
//     { tileClassName: '', tileIconClass: '', typeCourse: '', nameCourse: '', competence: '', activeElementClass: null }
// ]
























































// const settings = {
//     "spanish" : {
//         "default" : true,
//         "login" : {
//           "title" : "Iniciar sesión",
//           "fieldID" : "ID",
//           "fieldUser" : "Correo electrónico",
//           "fieldPassword" : "Contraseña",
//           "fieldCheck" : "Recordarme",
//           "button" : "Iniciar sesión",
//           "buttonLanguage1" : "Español",
//           "buttonLanguage2" : "Inglés"
//         },
//         "menu" : [
//             {
//                 "classIcon" : "iconMenu bi bi-house-door home",
//                 "text" : "Inicio",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-star star",
//                 "text" : "Favoritos",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-file-text test",
//                 "text" : "Evaluaciones",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-people groups",
//                 "text" : "Grupos",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-mortarboard students",
//                 "text" : "Estudiantes",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-bar-chart-line progress",
//                 "text" : "Progreso",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-list-ol topics",
//                 "text" : "Temario",
//                 "link" : "#"
//             }
//         ],
//         "profile" : "Student",
//         "quickAccess" : [
//             {
//                 "indexCourse" : 0,
//                 "indexCompetence" : 1
//             },
//             {
//                 "indexCourse" : 1,
//                 "indexCompetence" : 0
//             },
//             {
//                 "indexCourse" : 2,
//                 "indexCompetence" : 2
//             }
//         ],
//         "courses" : [
//             {
//                 "tileClassName" : "",
//                 "tileIconClass" : "bi bi-file-earmark-excel",
//                 "typeCourse" : "Certificación",
//                 "nameCourse" : "Excel 365",
//                 "level" : "Enterprise",
//                 "percentageCompleted" : 50,
//                 "activeElementClass" : "DegradedExcel",
//                 "topics" : [
//                     {
//                         "topic" : "Fórmulas y funciones de Excel",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Tablas e informes dinámicos",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Gráficos dinámicos",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     }
//                 ]
//             },
//             {
//                 "tileClassName" : "",
//                 "tileIconClass" : "bi bi-file-earmark-word",
//                 "typeCourse" : "Certificación",
//                 "nameCourse" : "Word 365",
//                 "level" : "Enterprise",
//                 "percentageCompleted" : 35,
//                 "activeElementClass" : "DegradedWord",
//                 "topics" : [
//                     {
//                         "topic" : "Fórmulas y funciones de Excel",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Tablas e informes dinámicos",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Gráficos dinámicos",
//                         "competences" : [
//                             {
//                                 "name" : "Competencia #1"
//                             },
//                             {
//                                 "name" : "Competencia #2"
//                             },
//                             {
//                                 "name" : "Competencia #3"
//                             }
//                         ]
//                     }
//                 ]
//             }
//         ],
        
//     },
//     "english" : {
//         "default" : false,
//         "login" : {
//           "title" : "Login",
//           "fieldID" : "ID",
//           "fieldUser" : "User",
//           "fieldPassword" : "Password",
//           "fieldCheck" : "Remember me",
//           "button" : "Login",
//           "buttonLanguage1" : "Spanish",
//           "buttonLanguage2" : "English"
//         },
//         "menu" : [
//             {
//                 "classIcon" : "iconMenu bi bi-house-door home",
//                 "text" : "Home",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-star star",
//                 "text" : "Favorites",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-file-text test",
//                 "text" : "Tests",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-people groups",
//                 "text" : "Groups",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-mortarboard students",
//                 "text" : "Students",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-bar-chart-line progress",
//                 "text" : "Progress",
//                 "link" : "#"
//             },
//             {
//                 "classIcon" : "iconMenu bi bi-list-ol topics",
//                 "text" : "Topics",
//                 "link" : "#"
//             }
//         ],
//         "profile" : "Student",
//         "quickAccess" : [
//             {
//                 "indexCourse" : 0,
//                 "indexCompetence" : 5
//             },
//             {
//                 "indexCourse" : 1,
//                 "indexCompetence" : 0
//             },
//             {
//                 "indexCourse" : 2,
//                 "indexCompetence" : 2
//             }
//         ],
//         "courses" : [
//             {
//                 "tileClassName" : "",
//                 "tileIconClass" : "bi bi-file-earmark-excel",
//                 "typeCourse" : "Certification",
//                 "nameCourse" : "Excel 365",
//                 "level" : "Enterprise",
//                 "percentageCompleted" : 50,
//                 "activeElementClass" : "DegradedExcel",
//                 "topics" : [
//                     {
//                         "topic" : "Formulas and functions",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Dynamic tables and reports",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Dynamic charts",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     }
//                 ]
//             },
//             {
//                 "tileClassName" : "",
//                 "tileIconClass" : "bi bi-file-earmark-word",
//                 "typeCourse" : "Certification",
//                 "nameCourse" : "Word 365",
//                 "level" : "Enterprise",
//                 "percentageCompleted": 35,
//                 "activeElementClass" : "DegradedWord",
//                 "topics" : [
//                     {
//                         "topic" : "Formulas and functions",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Dynamic tables and reports",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     },
//                     {
//                         "topic" : "Dynamic charts",
//                         "competences" : [
//                             {
//                                 "name" : "Competence #1"
//                             },
//                             {
//                                 "name" : "Competence #2"
//                             },
//                             {
//                                 "name" : "Competence #3"
//                             }
//                         ]
//                     }
//                 ]
//             }
//         ]
//     }
// }